<script>
export default {
	lang: 'shop',
	props: ['order', 'joinedItem'],
	computed: {
		isMobile() {
			return this.$vuetify.breakpoint.xs
		},
		currency() {
			return this.order.currency.sign
		},
	},
	cssVars: {
		selector: '.cart-drawer__item',
	},
}
</script>

<template>
	<div v-if="joinedItem.children.length" class="d-flex flex-column" style="gap: 8px">
		<div
			class="d-flex align-center w100"
			v-for="(item, index) of joinedItem.children"
			:key="`child-${index}`"
		>
			<v-icon class="mr-2 flex-shrink-0" color="primary" size="28">mdi-plus</v-icon>
			<div
				:key="`child-${item.id}`"
				class="cart-drawer__itemchild rounded base grey lighten-3 d-flex align-center flex-wrap flex-sm-nowrap px-4 py-2 w100"
			>
				<div style="width: 45px; height: 45px" class="flex-shrink-0 mr-4">
					<Media
						:src="item.image"
						aspect-ratio="1"
						class="rounded-circle d-block"
						style="border: 1px solid #ddd; cursor: pointer; height: auto; width: 100%; overflow: hidden"
					/>
				</div>
				<div class="w100">
					<div>
						{{ item.name }}
					</div>
					<div v-if="item.descriptions" class="font-0 grey--text">
						{{ item.descriptions.map((e) => e.text).join(' | ') }}
					</div>
				</div>
				<div class="flex-shrink-0 nowrap d-flex align-center" style="gap: 8px">
					<div class="font-1">{{ item.qty }}x</div>
					<ProductPrevPrice
						v-if="item.initTotal > item.finalTotal"
						:amount="item.initTotal"
						:currency="currency"
						class="font-0"
					/>
					<ProductPrice custom-class="font-2 price" :amount="item.finalTotal" :currency="currency" />
				</div>
			</div>
		</div>
	</div>
</template>

